export default "__VITE_ASSET__CQfbBnl5__"